<template>
  <div class="yxtbiz-category-tree" v-infinite-scroll="load">
    <yxt-input
      class="yxtbiz-category-tree-search"
      v-model="keyword"
      searchable
      :placeholder="placeholder"
      @search="search"
      :maxlength="20"
      clearable
    ></yxt-input>
    <div class="yxtbiz-category-tree-content">
      <yxt-empty v-if="empty" />
      <tree-node
        :sort="sort"
        :deleteFunc="deleteFunc"
        v-else-if="data && data.nodeId"
        :handle-click="handleClick"
        :handle-check="handleCheck"
        :showForm="showForm"
        :disabledLast="disabledLast"
        :selectedId="selectedId"
        :checkedIds="checkedIds"
        :data="data"
        :multiple="multiple"
        pnodeId="0"
        :index="0"
        :expandAll="expandAll"
        :expandedDefault="true"
        :sortable="sortable && hasAllPermission"
        :firstModifiable="firstModifiable"
        :modifiable="modifiable"
        :get-cate-children="getCateChildren"
      ></tree-node>
    </div>

    <yxt-drawer
      :title="title"
      :visible.sync="formVisble"
      size="640px"
      @closed="formVisble = false"
      :before-close="beforeClose"
      ref="drawer"
    >
      <category-form
        ref="form"
        :code="code"
        :apiName="apiName"
        :dataPermissionCode="dataPermissionCode"
        :navCode="navCode"
        :showDes="showDes"
        v-if="formVisble"
      ></category-form>
      <div slot="footer">
        <yxt-button type="plain" @click="handleClose">{{
          $t('pc_biz_common_cancel_mini').d('取消')
        }}</yxt-button>
        <yxt-button type="primary" @click="submit">{{
          $t('pc_biz_common_btn_sure').d('确定')
        }}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>
<script>
import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';
import Vuex from 'vuex';
import treeStore from './store';
import TreeNode from './components/tree-node';
import CategoryForm from './components/category-form';
import {
  searchCategoryByName,
  searchMgrCategoryByName,
  getManageCategoryData,
  getStuCategoryData,
  updateCate,
  insertCate,
  sortNode,
  deleteCate,
  getNodeDeatil
} from './service';
import { http } from 'yxt-biz-pc/packages/api';
export default {
  name: 'YxtbizCategoryTree',
  store: new Vuex.Store(treeStore),
  components: {
    TreeNode,
    CategoryForm
  },
  data() {
    return {
      keyword: '',
      data: {},
      expandAll: false,
      isSearching: false,
      empty: false,
      formVisble: false,
      formCallback: null, // 表单保存后的回调函数
      checkedMap: {},
      activeNode: null,
      title: '',
      hasAllPermission: false,
      apiInstance: null
    };
  },
  props: {
    apiName: {
      type: String,
      default: 'dmp'
    },
    code: {
      type: String,
      required: true
    },
    selectedId: {
      type: String,
      default: '' // 单选-默认选中的分类nodeId
    },
    checkedIds: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 默认展开的数据
    expanded: {
      type: Array,
      default: () => {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    sortable: {
      type: Boolean,
      default: true
    },
    navCode: {
      type: String
    },
    dataPermissionCode: {
      type: String
    },
    type: {
      type: Number,
      default: 0 // 0 管理端，1学员端
    },
    placeholder: {
      type: String,
      default: () => i18n.t('biz_pc_search_pl').d('请输入关键字搜索')
    },
    // 一级分类是否允许增删改
    firstModifiable: {
      type: Boolean,
      default: true
    },
    // 除一级分类以外的分类是否允许增删改
    modifiable: {
      type: Object,
      default: () => {
        return {
          add: true,
          delete: true,
          modify: true
        };
      }
    },
    showDes: {
      type: Boolean,
      default: true
    },
    disabledLast: {
      type: Boolean,
      default: false
    },
    // 多选最大数量
    limit: {
      type: Number,
      default: 100
    }
  },

  async created() {
    this.apiInstance = http[this.apiName];
    if (!this.apiInstance) {
      alert('http实例初始化失败');
      return;
    }
    console.log(this.modifiable);
    this.getTreeDetail();
  },
  watch: {
    checkedIds() {
      this.resetCheckedMap();
    },
    selectedId(v) {
      if (!v) {
        if (this.activeNode) {
          this.activeNode.active = false;
        }
        this.activeNode = null;
      } else if (this.activeNode && this.activeNode.nodeId !== v) {
        this.activeNode.active = false;
      }
    }
  },
  methods: {
    handleClose() {
      this.$refs.drawer.closeDrawer();
    },
    beforeClose(done) {
      const changed = this.$refs.form.isChanged;
      done(changed);
    },
    load() {},
    // 逐级展开下一分类，获取子分类列表
    getCateChildren(nodeId) {
      const params = {
        dataPermsCode: this.dataPermissionCode,
        navCode: this.navCode,
        treeId: this.code,
        pnodeId: nodeId
      };
      return this.type
        ? getStuCategoryData(params, this.apiInstance)
        : getManageCategoryData(params, this.apiInstance);
    },
    async getTreeDetail() {
      try {
        this.expandAll = false;
        const res = await this.getCateChildren('1');
        this.data = res.node;
        this.hasAllPermission = !!res.sortable;
      } catch (error) {
        console.error('查询子节点失败:', error);
      }
    },
    searchByName(data) {
      return this.type
        ? searchCategoryByName(data, this.apiInstance)
        : searchMgrCategoryByName(data, this.apiInstance);
    },
    // 搜索后并展开所有节点
    async search() {
      try {
        this.empty = false;
        if (!this.keyword) {
          this.expandAll = false;
          this.getTreeDetail();
          return;
        }
        const { node } = await this.searchByName({
          dataPermsCode: this.dataPermissionCode,
          navCode: this.navCode,
          treeId: this.code,
          keyword: this.keyword
        });
        if (node) {
          this.data = node;
          this.expandAll = true;
        } else {
          this.empty = true;
        }
      } catch (e) {
        console.error('查询失败', e);
      }
    },
    handleClick(node, emit = 1) {
      if (this.activeNode) {
        this.activeNode.active = false;
      }
      if (node) {
        node.active = true;
        this.activeNode = node;
      }
      emit &&
        this.$emit('select', {
          nodeId: node.nodeId,
          nodeName: node.nodeName
        });
    },
    // 重置已勾选的map
    resetCheckedMap() {
      for (const key in this.checkedMap) {
        const node = this.checkedMap[key];
        if (node && !this.checkedIds.includes(key)) {
          node.checked = false;
          delete this.checkedMap[key];
        }
      }
    },
    handleCheck(isChecked, node, emit = 1) {
      if (!node) return;
      if (isChecked) {
        // 超过最大数量限制则不允许勾选
        if (this.checkedIds.length >= this.limit && emit) {
          node.checked = false;
          this.$message.warning(
            this.$t('pc_biz_cate_max_limit', { 0: this.limit }).d(
              `最多选择${this.limit}个分类`
            )
          );
          return;
        }
        // 新增勾选
        node.checked = true;
        this.checkedMap[node.nodeId] = node;

        if (emit) {
          this.$emit('addChecked', {
            nodeId: node.nodeId,
            nodeName: node.nodeName
          });
        }
      } else {
        // 删除map
        let mapNode = this.checkedMap[node.nodeId];
        if (!mapNode) return;
        mapNode.checked = false;
        delete this.checkedMap[node.nodeId];
        emit && this.$emit('removeChecked', node);
      }
    },
    async showForm({ type, nodeId, callback, nodeName }) {
      this.formVisble = true;
      this.formCallback = callback || null;
      let form;
      if (type === 'create') {
        this.title = this.$t('pc_common_category_insert').d('新增');
        form = {
          treeId: this.code,
          pnodeId: nodeId,
          pnodeName: nodeName
        };
      } else {
        this.title = this.$t('pc_common_cate_edit').d('编辑');
        const detail = await getNodeDeatil(
          {
            treeId: this.code,
            nodeId: nodeId
          },
          this.apiInstance
        );
        form = detail;
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.show(form);
      });
    },
    async submit() {
      try {
        await this.$refs.form.validate();
        const params = this.$refs.form.form;
        if (!this.firstModifiable && params.pnodeId === '1') {
          return this.$message.error(
            this.$t('biz_cate_form_error_pnode').d('所属分类不支持选择根分类')
          );
        } else if (params.pnodeId === params.nodeId) {
          return this.$message.error(
            this.$.t('biz_pc_from_error_pnode_cant_be_self').d(
              '所属分类不可与当前分类相同'
            )
          );
        }
        if (params.nodeId) {
          await updateCate(params, this.apiInstance);
        } else {
          const res = await insertCate(params, this.apiInstance);
          params.nodeId = res.id;
        }
        this.formVisble = false;
        // 更新所属分类下的所有
        this.formCallback && this.formCallback(params);
      } catch (e) {
        e && e.error && this.$message.error(e.error.message || '保存失败');
      }
    },
    sort(data) {
      return sortNode(
        Object.assign(
          {
            treeId: this.code
          },
          data
        ),
        this.apiInstance
      );
    },
    deleteFunc(data) {
      return deleteCate(
        Object.assign(
          {
            treeId: this.code
          },
          data
        ),
        this.apiInstance
      );
    }
  }
};
</script>
